<template>
    <div class='cron-editor'>
        <div style="font-size: 14px;padding: 4px;height: 30px;">
            <span style="color:darkgray">描述 </span><span :class="{'font-red' : !cronIsValid }">{{cronDesc}}</span>
            <span v-show="apiFuncForTryCalc && cronIsValid" style="float: right;margin-top: -2px;"><el-link style="color:navy;font-size:12px;" @click="handleTryCalc">试算时间</el-link></span>
        </div>
        <swb-cron-field-item class="cron-field" ref="cronYearCtrl" :model="cronYear" @change="syncCronField" :fixedType="fixedYearType" :fixedValue="fixedYear"></swb-cron-field-item>
        <swb-cron-field-item class="cron-field" ref="cronMonthCtrl" :model="cronMonth" @change="syncCronField" :fixedType="fixedMonthType" :useWkDay="useWkDay" @month-useWkDay="syncUseWkDayUI"></swb-cron-field-item>
        <swb-cron-field-item class="cron-field" v-show="useWkDay" ref="cronWkDayCtrl" :model="cronWkDay" @change="syncCronField"></swb-cron-field-item>
        <swb-cron-field-item class="cron-field" v-show="!useWkDay" ref="cronDayCtrl" :model="cronDay" @change="syncCronField" :fixedType="fixedDayType"></swb-cron-field-item>
        <swb-cron-field-item class="cron-field" ref="cronHourCtrl" :model="cronHour" @change="syncCronField" :fixedType="fixedHourType"></swb-cron-field-item>
        <swb-cron-field-item class="cron-field" ref="cronMinuteCtrl" :model="cronMinute" @change="syncCronField" :fixedType="fixedMinuteType"></swb-cron-field-item>
        <swb-cron-field-item class="cron-field" v-if="showSecond" ref="cronSecondCtrl" :model="cronSecond" @change="syncCronField" :fixedType="fixedSecondType"></swb-cron-field-item>
        <div class="time-limit" v-if="theLimit != null">
            <span :class="{'font-red' : !limitValidate }">截止条件</span>：
            <el-radio-group v-model="theLimit.limitType" @change="calcTimeLimit" style="margin-right: 20px;">
                <el-radio v-for="limitItem in limitItems" :disabled="disabledLimitType == limitItem['value']" style="color:navy;" :label="limitItem['value']">
                    {{limitItem['text']}}
                </el-radio>
            </el-radio-group>
            <div v-show="theLimit.limitType == 0" style="display: inline-block">
                <!-- 仅作为占位符,防止界面跳动 -->
                <el-input type="number" style="visibility: hidden;"></el-input>
            </div>
            <div v-show="theLimit.limitType == 1" style="display: inline-block">
                <el-input v-model="theLimit.limitTimes" type="number" @blur="calcTimeLimit" style="color:navy;width: 80px;text-align: center"></el-input>
                次
            </div>
            <div v-show="theLimit.limitType == 2" style="display: inline-block">
                <el-date-picker v-model="theLimit.limitTimed" type="datetime" @change="calcTimeLimit" style="width:180px;" :format="timeFormat"></el-date-picker>
                为止
            </div>
        </div>
    </div>
</template>

<script>
    // last modified by koqiui
    import { Utils, Jqext } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    let Toast = Jqext.Toast;

    import {
        CronField,
        JsonCron,
        TIME_LIMIT_TYPE
    } from './json-cron.js'

    import CronFieldItem from './CronFieldItem.vue';

    Vue.regist(CronFieldItem);

    //
    const LIMIT_TYPE = TIME_LIMIT_TYPE;
    const Limit_items = [{
        value: LIMIT_TYPE.NONE,
        text: '无'
    }, {
        value: LIMIT_TYPE.TIMES,
        text: '次数为'
    }, {
        value: LIMIT_TYPE.TIMED,
        text: '时间到'
    }];

    function findAnotherLimitType(excludedLimitType) {
        let retLimitType = null;
        for(let i = 0, l = Limit_items.length; i < l; i++) {
            let item = Limit_items[i];
            if(item.value != excludedLimitType) {
                retLimitType = item.value;
                break;
            }
        }
        return retLimitType;
    }

    export default {
        name: 'swb-cron-editor',
        desc: 'Cron表达式编辑器',
        props: {
            //各域初始值
            jsonValue: {
                type: Object,
                default: {}
            },
            //
            fixedYearType: {
                type: Boolean,
                default: false,
            },
            fixedMonthType: {
                type: Boolean,
                default: false,
            },
            fixedDayType: {
                type: Boolean,
                default: false,
            },
            fixedHourType: {
                type: Boolean,
                default: false,
            },
            fixedMinuteType: {
                type: Boolean,
                default: false,
            },
            fixedSecondType: {
                type: Boolean,
                default: false,
            },
            //是否固定年份（不能更改，如果不给值，则为当前年份）
            fixedYear: {
                type: Boolean,
                default: false
            },
            //是否显示秒钟
            showSecond: {
                type: Boolean,
                default: false
            },
            //定时截止条件
            timeLimit: {
                type: Object, // { limitType(限制类型：TIME_LIMIT_TYPE), limitTimes(限定的次数), limitTimed(限定的时间点 yyyy-MM-dd HH:mm:ss)}
                default: null
            },
            //禁用的截止限制类型
            disabledLimitType: {
                type: Number,
                default: LIMIT_TYPE.TIMES
            },
            // 试算api函数/方法
            //(data { cronData, calcTimes[, fromTime]}, callback({type, data : []}))
            apiFuncForTryCalc: {
                type: Function
            }
        },
        components: {
            CronFieldItem
        },
        data() {
            return {
                // => CronField
                cronYear: null,
                cronMonth: null,
                cronWkDay: null,
                cronDay: null,
                cronHour: null,
                cronMinute: null,
                cronSecond: null,
                //
                useWkDay: false,
                //
                cronIsValid: true,
                cronDesc: null,
                //
                limitValidate: true,
                limitItems: Utils.merge(Limit_items),
                timeFormat: 'yyyy-MM-dd HH:mm:ss',
                theLimit: null
            };
        },
        computed: {},
        watch: {
            jsonValue(newVal, oldVal) {
                this.initMiscFields();
            },
            fixedYearType(newVal, oldVal) {
                this.initMiscFields();
            },
            fixedMonthType(newVal, oldVal) {
                this.initMiscFields();
            },
            fixedDayType(newVal, oldVal) {
                this.initMiscFields();
            },
            fixedHourType(newVal, oldVal) {
                this.initMiscFields();
            },
            fixedMinuteType(newVal, oldVal) {
                this.initMiscFields();
            },
            fixedSecondType(newVal, oldVal) {
                this.initMiscFields();
            },
            fixedYear(newVal, oldVal) {
                this.initMiscFields();
            },
            showSecond(newVal, oldVal) {
                this.initMiscFields();
            },
            timeLimit(newVal, oldVal) {
                this.initMiscFields();
            },
            disabledLimitType(newVal, oldVal) {
                this.initMiscFields();
            },
            //-----------------------
            cronYear(newVal, oldVal) {
                this.calcCronFields();
            },
            cronMonth(newVal, oldVal) {
                this.calcCronFields();
            },
            cronWkDay(newVal, oldVal) {
                this.calcCronFields();
            },
            cronDay(newVal, oldVal) {
                this.calcCronFields();
            },
            cronHour(newVal, oldVal) {
                this.calcCronFields();
            },
            cronMinute(newVal, oldVal) {
                this.calcCronFields();
            },
            cronSecond(newVal, oldVal) {
                this.calcCronFields();
            }
        },
        created() {
            this.initMiscFields();
        },
        methods: {
            syncCronField(model) {
                let fieldName = model.name;
                let field = new CronField().fromJson(model);
                switch(fieldName) {
                    case CronField.NAME.Year :
                        this.cronYear = field;
                        break;
                    case CronField.NAME.Month :
                        this.cronMonth = field;
                        break;
                    case CronField.NAME.WkDay :
                        this.cronWkDay = field;
                        break;
                    case CronField.NAME.Day :
                        this.cronDay = field;
                        break;
                    case CronField.NAME.Hour :
                        this.cronHour = field;
                        break;
                    case CronField.NAME.Minute :
                        this.cronMinute = field;
                        break;
                    case CronField.NAME.Second :
                        this.cronSecond = field;
                        break;
                }
            },
            syncUseWkDayUI(monthUseWkDay) {
                this.useWkDay = monthUseWkDay;
            },
            //
            initMiscFields() {
                let jsonValue = this.jsonValue || {};
                //处理固定年份问题
                if(this.fixedYear) {
                    let initVal = jsonValue.Year == null ? null : jsonValue.Year.value;
                    jsonValue.Year = Utils.merge(jsonValue.Year, new CronField(CronField.NAME.Year, CronField.TYPE.Spec).toJson());
                    if(initVal == null) {
                        initVal = new Date().getFullYear();
                    }
                    jsonValue.Year.value = initVal;
                }
                //
                this.useWkDay = jsonValue.WkDay != null;
                //
                this.cronYear = new CronField(CronField.NAME.Year).fromJson(jsonValue.Year);
                this.cronMonth = new CronField(CronField.NAME.Month).fromJson(jsonValue.Month);
                this.cronWkDay = new CronField(CronField.NAME.WkDay).fromJson(jsonValue.WkDay);
                this.cronDay = new CronField(CronField.NAME.Day).fromJson(jsonValue.Day);
                this.cronHour = new CronField(CronField.NAME.Hour).fromJson(jsonValue.Hour);
                this.cronMinute = new CronField(CronField.NAME.Minute).fromJson(jsonValue.Minute);
                //
                if(this.showSecond) {
                    jsonValue.Second = Utils.merge(new CronField(CronField.NAME.Second, CronField.TYPE.Spec).toJson(), jsonValue.Second || {});
                    if(jsonValue.Second.type == CronField.TYPE.Spec && jsonValue.Second.value == null) {
                        jsonValue.Second.value = 0;
                    }
                    //
                    this.cronSecond = new CronField(CronField.NAME.Second).fromJson(jsonValue.Second);
                    //
                    this.timeFormat = 'yyyy-MM-dd HH:mm:ss'
                }
                else {
                    this.cronSecond = null;
                    //
                    this.timeFormat = 'yyyy-MM-dd HH:mm'
                }
                //
                this.theLimit = this.timeLimit == null ? null : Utils.merge({
                    limitType: LIMIT_TYPE.NONE
                }, this.timeLimit);
                //根据禁用的限制类型调整默认限制类型
                if(this.theLimit != null && (this.theLimit.limitType == this.disabledLimitType || this.theLimit.limitType == null)) {
                    this.theLimit.limitType = findAnotherLimitType(this.disabledLimitType);
                }
                //theLimit 初始为null，不易触发监听
                setTimeout(this.calcTimeLimit, 3000);
            },
            //
            calcCronFields() {
                let jsonCron = new JsonCron();
                //
                jsonCron.Year = this.cronYear;
                jsonCron.Month = this.cronMonth;
                if(this.useWkDay) {
                    jsonCron.WkDay = this.cronWkDay;
                }
                else {
                    jsonCron.Day = this.cronDay;
                }
                jsonCron.Hour = this.cronHour;
                jsonCron.Minute = this.cronMinute;
                jsonCron.Second = this.cronSecond;
                //验证cron表达式
                this.cronIsValid = jsonCron.validate();
                //
                this.cronDesc = jsonCron.getDesc();
                //
                return jsonCron;
            },
            calcTimeLimit() {
                if(this.theLimit == null) {
                    this.limitValidate = true;
                    return null;
                }
                //
                let limitValidate = true;
                let retLimit = Utils.merge({}, this.theLimit);
                let limitType = retLimit.limitType;
                if(limitType == null) {
                    delete retLimit['limitTimes'];
                    delete retLimit['limitTimed'];
                    limitValidate = false;
                }
                else if(limitType == LIMIT_TYPE.TIMES) {
                    delete retLimit['limitTimed'];
                    //
                    if(!Utils.isNaturalStr(retLimit.limitTimes, true)) {
                        limitValidate = false;
                    }
                    retLimit.limitTimes = Utils.ParseInt(retLimit.limitTimes);
                }
                else if(limitType == LIMIT_TYPE.TIMED) {
                    delete retLimit['limitTimes'];
                    //
                    if(retLimit.limitTimed == null) {
                        limitValidate = false;
                    }
                    if(retLimit.limitTimed instanceof Date) {
                        let limitTimed = retLimit.limitTimed.format(this.timeFormat);
                        //统一带秒
                        retLimit.limitTimed = Date.parseAsDate(limitTimed).format('yyyy-MM-dd HH:mm:ss');
                    }
                }
                else {//limitType == LIMIT_TYPE.NONE
                    delete retLimit['limitTimes'];
                    delete retLimit['limitTimed'];
                }
                //
                this.limitValidate = limitValidate;
                //
                return retLimit;
            },
            //
            handleTryCalc() {
                let jsonCron = this.calcCronFields();
                if(!this.cronIsValid || !this.apiFuncForTryCalc) {
                    return;
                }
                //
                let cronData = JSON.encode(jsonCron.toJson());
                let self = this;
                MsgBox.prompt('要试算的时间点次数', function (val) {
                    let calcTimes = self.calcTimes = Utils.ParseInt(val);
                    //
                    let loader = MsgBox.loading('试算中...');
                    self.apiFuncForTryCalc({
                        cronData: cronData,
                        calcTimes: calcTimes,
                        fromTime: null //从当前时间算起
                    }, function (result) {
                        loader.hide();
                        //
                        if(result.success) {
                            let timeList = result.data;
                            let timeCount = timeList.length;
                            let msgHeight = Math.min(Math.max(240, 180 + timeCount * 36), 800);
                            let msgTextList = [];
                            for(let i = 0; i < timeCount; i++) {
                                msgTextList[i] = (i + 1) + '、 ' + timeList[i];
                            }
                            let msgHtml = timeCount == 0 ? '<span style="color:darkgoldenrod"> &lt; 无后续时间点 &gt; </span>' : msgTextList.join('<br/><br/>');

                            MsgBox.success(msgHtml, {
                                width: 480,
                                height: msgHeight,
                                title: '最近 ' + calcTimes + ' 个时间点如下'
                            });
                        }
                        else {
                            MsgBox.failure(result.message);
                        }
                    });
                }, {
                    title: '请输入',
                    width: 300,
                    height: 220,
                    type: 'text',
                    maxLength: 2,
                    value: self.calcTimes || 10
                });
            },
            getResult() {
                let result = {
                    type: 'info'
                };
                //
                let jsonCron = this.calcCronFields();
                let theLimit = this.calcTimeLimit();
                let validate = this.cronIsValid && this.limitValidate;
                if(validate) {
                    //json cron json
                    result.data = jsonCron.toJson();
                    //json cron singleFixedTime
                    result.singleFixedTime = jsonCron.isSingleFixedTime();
                    //json cron desc
                    result.dataDesc = this.cronDesc;
                    //time limit
                    result.dataEx = theLimit;
                }
                else {
                    result.type = 'warn';
                    result.message = !this.cronIsValid ? "表达式无效" : "时间限制无效";
                }
                //
                return result;
            }
        }
    }
</script>

<style scoped>
    .cron-editor {
        border: 1px dotted #EEEEEE;
        min-width: 500px;
    }

    .cron-editor .cron-field {
        border-top: 1px dotted #EEEEEE;
    }

    .cron-editor .cron-field:last-child {
        border-bottom: 1px dotted #EEEEEE;
    }

    .cron-editor .time-limit:last-child {
        padding: 6px 4px;
        border-top: 1px dotted #EEEEEE;
        font-size: 14px;
        height: 48px;
        line-height: 34px;
        background-color: #FEFEFE;
    }

</style>



// WEBPACK FOOTER //
// src/compo/cron/CronEditor.vue